import * as React from 'react';

import { Query } from '@apollo/client/react/components';

import { Panel } from '@admin/components/helpers/panel';
import { client } from '@admin/libraries/apollo';
import { PalletTasksDocument } from '@admin/schema';
import { IPalletTask } from '@admin/types/pallet_task';

import { PalletTaskImages } from './pallet_task_images';

interface IQueryData {
  palletTasks: IPalletTask[];
}

export const LocationImagesPanel: React.FC<{ destinationLocationID: string; timezone: string }> = ({
  destinationLocationID,
  timezone,
}) => (
  <Query<IQueryData, { destinationLocationID: string }>
    client={client}
    query={PalletTasksDocument}
    variables={{ destinationLocationID }}
  >
    {({ data, loading }) => {
      if (!data || loading) {
        return null;
      }

      return (
        <Panel>
          <Panel.Header>
            <Panel.Title>Images from Pallet Tasks</Panel.Title>
          </Panel.Header>
          <Panel.Body>{data && <PalletTaskImages palletTasks={data.palletTasks} timezone={timezone} />}</Panel.Body>
        </Panel>
      );
    }}
  </Query>
);
